import { render } from "./DiscogsCallback.vue?vue&type=template&id=9f165ffc&scoped=true"
import script from "./DiscogsCallback.vue?vue&type=script&lang=js"
export * from "./DiscogsCallback.vue?vue&type=script&lang=js"

import "./DiscogsCallback.vue?vue&type=style&index=0&id=9f165ffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f165ffc"]])

export default __exports__